import React from 'react';
import { SPLIT_SEGMENT_CLASSES } from './quoteStyles';

interface AllocationSplitBarProps {
    allocations: Array<{ supplierName: string; sharePercent: number }>;
}

/** Horizontal stacked bar visualizing how the award is split across suppliers. */
const AllocationSplitBar: React.FC<AllocationSplitBarProps> = ({ allocations }) => {
    if (allocations.length === 0) return null;

    return (
        <div className="flex flex-col gap-s2">
            <div className="flex h-[13px] w-full overflow-hidden rounded-pill bg-neutral-bg">
                {allocations.map((allocation, idx) => (
                    <div
                        key={allocation.supplierName}
                        className={`${SPLIT_SEGMENT_CLASSES[idx % SPLIT_SEGMENT_CLASSES.length]} transition-all duration-500`}
                        style={{ width: `${allocation.sharePercent}%` }}
                        title={`${allocation.supplierName} — ${allocation.sharePercent}%`}
                    />
                ))}
            </div>
            <div className="flex flex-wrap items-center gap-x-s5 gap-y-s1">
                {allocations.map((allocation, idx) => (
                    <div key={allocation.supplierName} className="flex items-center gap-s2 text-meta">
                        <span className={`h-[9px] w-[9px] rounded-round ${SPLIT_SEGMENT_CLASSES[idx % SPLIT_SEGMENT_CLASSES.length]}`} />
                        <span className="font-mono text-mono-data font-semibold text-ink">{allocation.sharePercent}%</span>
                        <span className="text-ink-secondary">{allocation.supplierName}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AllocationSplitBar;
